if (document.querySelector('.mobile-app')) {
    const mobileBlock = $('.mobile-app__animation');
    const iphoneBlock = mobileBlock.find('.iphone');
    const pixelBlock = mobileBlock.find('.pixel');

    const scrollHanlder = e => {
        const mobileBlockHeight = mobileBlock.height();
        const mobileBlockOffsetTop = mobileBlock.offset().top;
        const parentBlockHeight = mobileBlock.parent().height();

        if (($(window).width() - 100) / $(window).height() < 1) {
            if (scrollY > mobileBlockOffsetTop - screen.height) {
                iphoneBlock.addClass('is-active');
                pixelBlock.addClass('is-active');
            } else {
                iphoneBlock.removeClass('is-active');
                pixelBlock.removeClass('is-active');
            }
            if (scrollY > mobileBlockOffsetTop + mobileBlockHeight / 2) {
                iphoneBlock.removeClass('is-active');
                pixelBlock.removeClass('is-active');
            }
         } else {
            if (scrollY > mobileBlockOffsetTop - screen.height + parentBlockHeight / 2) {
                iphoneBlock.addClass('is-active');
                pixelBlock.addClass('is-active');
            } else {
                iphoneBlock.removeClass('is-active');
                pixelBlock.removeClass('is-active');
            }
            if (scrollY > mobileBlockOffsetTop + parentBlockHeight / 2) {
                iphoneBlock.removeClass('is-active');
                pixelBlock.removeClass('is-active');
            }
        }
    };

    window.addEventListener('scroll', scrollHanlder);
    window.addEventListener('resize', scrollHanlder);
}